import type { Project } from "../lib/types.js";

/**
 * A book's cover in the standard portrait (2:3) aspect. Uses the uploaded image
 * (cover-cropped, never distorted) when present, otherwise a clean generated
 * placeholder built from the title and author with subtle ClovaScribe styling.
 */
export function CoverArt({ project }: { project: Pick<Project, "title" | "author" | "coverImage"> }) {
  if (project.coverImage) {
    return (
      <div
        className="cover-art"
        style={{ backgroundImage: `url(${project.coverImage})` }}
        role="img"
        aria-label={`${project.title} cover`}
      />
    );
  }
  return (
    <div className="cover-art cover-placeholder">
      <div className="cover-ph-top">ClovaScribe</div>
      <div className="cover-ph-title">{project.title}</div>
      {project.author && <div className="cover-ph-author">{project.author}</div>}
      <div className="cover-ph-rule" />
    </div>
  );
}
